document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-swipe-gallery]').forEach(card => {
    const images = card.querySelectorAll('img');
    if (images.length < 2) return;

    let startX = 0;
    let isSwiping = false;
    let current = 0;

    // Watch the primary image for srcset changes (triggered by swatch tap)
    const primaryImg = card.querySelector('.product-featured-image-link img');
    if (primaryImg) {
      const observer = new MutationObserver(() => {
        // Theme swapped the variant image — reset swipe to show primary
        setTimeout(() => {
          images.forEach((img, i) => img.style.opacity = i === 0 ? '1' : '0');
          current = 0;
        }, 350);
      });
      observer.observe(primaryImg, { attributes: true, attributeFilter: ['srcset', 'src'] });
    }

    card.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      isSwiping = false;
    }, { passive: true });

    card.addEventListener('touchmove', e => {
      isSwiping = Math.abs(e.touches[0].clientX - startX) > 10;
    }, { passive: true });

    card.addEventListener('touchend', e => {
      if (!isSwiping) return;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        current = diff > 0 ? 1 : 0;
        images.forEach((img, i) => img.style.opacity = i === current ? '1' : '0');
      }
    });
  });
});

